import { createAsyncThunk } from "@reduxjs/toolkit";
import { GetAllVisits, GetMyVisits, GetVisitByID, AddNewVisit, UpdateVisit, DeleteVisit } from "../../helpers/api_method";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

export const getVisits = createAsyncThunk("visits/getVisits", async () => {
    try {
        const response = await GetAllVisits();
        if (response && response.data) {
            return response.data;
        }
        return response || [];
    } catch (error: any) {
        console.error("Error fetching visits:", error);
        return [];
    }
});

export const getMyVisits = createAsyncThunk("visits/getMyVisits", async () => {
    try {
        const response = await GetMyVisits();
        if (response && response.data) {
            return response.data;
        }
        return response || [];
    } catch (error: any) {
        console.error("Error fetching my visits:", error);
        return [];
    }
});

export const getVisitById = createAsyncThunk("visits/getVisitById", async (id: string) => {
    try {
        const response = await GetVisitByID(id);
        if (response && response.data) {
            return response.data;
        }
        return response;
    } catch (error: any) {
        console.error("Error fetching visit:", error);
        throw error;
    }
});

export const addVisit = createAsyncThunk("visits/addVisit", async (visit: any) => {
    try {
        const response = await AddNewVisit(visit);
        const data = response;
        if (data && data.data) {
            toast.success("Visit Added Successfully", { autoClose: 2000 });
            return data.data;
        }
        toast.success("Visit Added Successfully", { autoClose: 2000 });
        return data;
    } catch (error: any) {
        console.error("Error adding visit:", error);
        toast.error("Visit Added Failed", { autoClose: 2000 });
        throw error;
    }
});

export const updateVisit = createAsyncThunk("visits/updateVisit", async (visit: any) => {
    try {
        const response = await UpdateVisit(visit.id, visit);
        const data = response;
        if (data && data.data) {
            toast.success("Visit updated Successfully", { autoClose: 2000 });
            return data.data;
        }
        toast.success("Visit updated Successfully", { autoClose: 2000 });
        return data;
    } catch (error: any) {
        console.error("Error updating visit:", error);
        toast.error("Visit updated Failed", { autoClose: 2000 });
        throw error;
    }
});

export const deleteVisit = createAsyncThunk("visits/deleteVisit", async (visit: any) => {
    try {
        const response = await DeleteVisit(visit.id || visit);
        toast.success("Visit deleted Successfully", { autoClose: 2000 });
        return visit.id || visit;
    } catch (error: any) {
        console.error("Error deleting visit:", error);
        toast.error("Visit deleted Failed", { autoClose: 2000 });
        throw error;
    }
});
